<template>
    <div>
        <Modal
            class-name="vertical-center-modal"
            :value="showModel"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-change="openOrClose"  :styles="{'min-width':'700px','min-height':'50vh'}">
            
            <ul class="flex">
                <li v-for='(item,index) in dataList' :key='index'>
                    <div class="imgCon">
                        <img :src="item.photosurl" alt="" srcset="">
                    </div>
                     <p style="text-align: center">{{item.photosNmae}}</p>
                </li>
            </ul>
    
        </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
    export default {
        props: {
            showModel: Boolean,
            editFormData:Object,
            fn1:Function,
        },
        name: "SModel3",
        components: {
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                dataList:[]
            }
        },
        watch:{
            showModel(val){
                if(val){
                    this.getData()
                }
            }
        },
        methods: {
            getData(){
               let arr = this.editFormData.photos.split(',');
               let arr1 = []
               arr.map((item)=>{
                 let photosurl = this.config.sourceUrl+'?fid='+ item.split('_')[0]
                 let indexFlag = item.indexOf('_')+1
                 let photosNmae = item.slice(indexFlag,item.length)
                 arr1.push({photosurl,photosNmae})
               })
               this.dataList = arr1
            },
            openOrClose(value) {
                if(value === true) {    
                    this.title = this.$t('productManage.manageModel.stitle')
                }
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
                this.fn1()
            }
        }
    }
</script>

<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
ul{
    flex-wrap: wrap;
    li{
        width: 20%;
        margin-right: 20px;
    }
}
.imgCon{
    width: 100%;
    height: 300px;
    overflow: hidden;
    img{
        width: 100%;
        height: auto;
    }
}
</style>
